 
const icon1 = "https://www.winpeforum.com/assets/elements/AishwaryaJaishanker.jpg"; 
const icon2 = "https://www.winpeforum.com/assets/elements/AparnaJain.png"; 
const icon3 = "https://www.winpeforum.com/assets/elements/DivyaIyer.jpg"; 
const icon4 = "https://www.winpeforum.com/assets/elements/KhushbooShahani.png"; 
const icon5 = "https://www.winpeforum.com/assets/elements/KiranSharma.jpg"; 
const icon6 = "https://www.winpeforum.com/assets/elements/KritiGupta.png"; 
const icon7 = "https://www.winpeforum.com/assets/elements/KritikaAgarwal.jpg"; 
const icon8 = "https://www.winpeforum.com/assets/elements/SanjnaTulsiani.png"; 
const icon9 = "https://www.winpeforum.com/assets/elements/ShraddhaBanka.jpg"; 
const icon10 = "https://www.winpeforum.com/assets/elements/SurbhiGarg.jpg"; 
const icon11 = "https://www.winpeforum.com/assets/elements/VarunaKhattri.jpg"; 

const mentConstant4 = [
    {
        imgUrl: icon1,
        desc: `Aishwarya Jaishankar is co-founder and COO of Hyperface Technologies, a Fintech Infrastructure company that helps banks and brands create compelling credit programs. A veteran digital banker by background, Aishwarya has a track record of disruptive banking product development and scaling. She has played key roles in digital transformation success stories at large banks prior to starting up. A leading product voice in multiple Fintech events, she is an executive committee member of IFTA.
         `,
        name:"Aishwarya Jaishanker",
        company:"-",
        post:"-",
        oldpost:"Co-founder & COO",
        oldcompany:"Hyperface Technologies",
        linkedIn:"https://www.linkedin.com/in/aishwarya-jaishankar/?originalSubdomain=in",
    },
    {
        imgUrl: icon2,
        desc: `Aparna joined Multiples in 2020, in the portfolio management function and transitioned into the investor relations & fund-raising role in 2023. Prior to Multiples she spent 4+ years in the Financial Advisory practice at EY & Deloitte focussing on transactions along-side business risk consulting. She also worked with CRISIL (S&P) as part of their global Structured Finance team for rating Asset Backed Securities in North America. By way of education, she is a Chartered Accountant and holds a certificate The Wharton School, University of Pennsylvania for completing the executive course on ‘Leadership & Management in New Age Business’. She completed her articleship from PWC Assurance – Financial Services alongside pursuing her Bachelors from H.R. College of Commerce & Economics.<br/><br/>
Throughout her prior stints she has focused on developing a multi-faceted understanding of businesses and growth accelerators in different sectors  and fostered an approach to analyse facts in-depth before decision making while empathising with stakeholder concerns. In her current role, she focuses on investor engagements and strategic developments at Multiples.
Her interests include reading about history, culture and non-fiction content exploring human behaviour. She also enjoys travelling and painting.
         `,
        name:"Aparna Jain",
        company:"Brookfield Renewable",
        post:"Associate Director - Portfolio Management",
         oldpost:" AVP",
        oldcompany:"Multiples PE",
        linkedIn:"https://www.linkedin.com/in/aparna-jain-38813180/?originalSubdomain=in",
    },
   
    {
        imgUrl: icon4,
        desc: `Khushboo Shahani Khushboo Shahani is an Executive Director at Eversource Capital, specializing in investments in energy efficiency, resource efficiency, and e-mobility. With over 13 years of experience in alternative asset classes, she has overseen nearly USD 1 billion in investments across private equity, private credit, and special situations. At Eversource, Khushboo focuses on scaling investments in the circular economy and climate impact sectors. Her previous roles include Vice President at Everstone Capital Advisors, where she led deployments of over USD 150 million, and Chief Manager at SBI Funds Management, where she executed distressed transactions with targeted IRRs of 18-22%. Khushboo holds an MBA from SP Jain Institute of Management & Research and a Bachelor of Commerce from St. Francis College for Women, Hyderabad.

         `,
        name:"Khushboo Shahani",
        company:"-",
        post:"-",
         oldpost:"Executive Director",
        oldcompany:"Eversource Capital",
        linkedIn:"https://www.linkedin.com/in/khushbooshahani/?originalSubdomain=in",
    },
    {
        imgUrl: icon5,
        desc: `As a Senior Investment Analyst at Accion Emerge, Kiran is a global investment professional with extensive expertise in early-stage investments across emerging and frontier markets. Her career encompasses significant experience in valuation and financial modeling, and she has a strong track record in investment evaluation, deal execution, portfolio management, business advisory services, and business development. Kiran has led advisory groups providing technical and business assistance to manage growth and operational turnarounds.<br/><br/>
Previously, Kiran worked at Deloitte India in the Financial Services practice, specializing in business valuation and financial modeling. She holds an MBA from Narsee Monjee Institute of Management Studies. Kiran's key areas of expertise include financial modeling, investor relations, business valuations, and transaction advisory. Outside of work, she enjoys reading non-fiction books, traveling, and practicing origami.


         `,
        name:"Kiran Sharma",
        company:"-",
        post:"-",
         oldpost:"Senior Specialist Investment & Portfolio Management  ",
        oldcompany:"Accion Emerge",
        linkedIn:"https://www.linkedin.com/in/kiran-sharma-she-her-822a4956/",
    },
    {
        imgUrl: icon6,
        desc: `Kriti is a Venture Capital professional with a background in engineering from IIT Bombay and an MBA from Harvard Business School. She co-founded an AgTech startup during her undergraduate years, which, despite not taking off, provided her with valuable insights into the challenges founders face in building businesses from scratch. Her career began at Deutsche Bank, but her passion for the startup ecosystem led her to venture capital. Kriti has worked with a domestic VC firm and Silicon Valley funds focused on India, culminating in her current role at Peak XV Partners.
Kriti is drawn to founders with deep passion, high emotional intelligence, and an intimate understanding of the problems they aim to solve. She believes the best founders channel their industry experiences into a relentless drive to create transformative solutions, inspiring others through their vision. Kriti seeks to partner with such visionaries to help build enduring, impactful businesses


         `,
        name:"Kriti Gupta",
        company:"-",
        post:"-",
         oldpost:"Vice President",
        oldcompany:"Peak XV",
        linkedIn:"https://www.linkedin.com/in/kriti-gupta-50b58062/",
    },
    {
        imgUrl: icon7,
        desc: `Kritika Agarwal has over a decade of experience and is part of the Firm’s Corporate Group. Kritika’s practice focuses on advising multinational clients on acquisitions, divestitures, joint ventures, strategic alliances, and general corporate and commercial strategy.

         `,
        name:"Kritika Agarwal",
        company:"-",
        post:"-",
         oldpost:"Partner",
        oldcompany:"AZB & Partners",
        linkedIn:"https://www.linkedin.com/in/kritika-agarwal-377021119/?originalSubdomain=in",
    },
    
    {
        imgUrl: icon8,
        desc: "Sanjna has 8+ years of experience across venture growth investing, investor relations and equity research. Prior to joining Iron Pillar, Sanjna worked in a senior leadership role at Valorem Advisors, consulting at the CXO level for publicly listed companies, strategically advising them and representing their interests in the investor community. Sanjna has also worked at Morgan Stanley Capital International, where she was involved in the creation, rebalancing, and restructuring of public market indexes for developed & emerging markets. Sanjna is a CFA® Charter holder. She holds a Masters in Commerce (Finance & Accounting) and Bachelors in Management Studies (Finance) from the University of Mumbai.",

        name:"Sanjna Tulsiani",
        company:"Iron Pillar Fund",
        post:"Senior Vice President- Investments",
         oldpost:"Vice President",
        oldcompany:"Iron Pillar Fund",
        linkedIn:"https://www.linkedin.com/in/sanjna-t-9a7b9963/",
    },
    {
        imgUrl: icon9,
        desc: `Shraddha is Associate Vice President - Compliance at Lighthouse. Before joining Lighthouse, Shraddha worked with the Audit and Assurance Services Practice of KPMG, where she handled audits, tax and compliance-related assurance engagements of companies across sectors, including financial services and manufacturing.
Shraddha is a commerce graduate from the University of Mumbai.

         `,
        name:"Shraddha Banka",
        company:"-",
        post:"-",
         oldpost:"AVP - Compliance",
        oldcompany:"Lighthouse Funds",
        linkedIn:"https://www.linkedin.com/in/shraddha-b-a28967141/",
    },
	{
        imgUrl: icon10,
        desc: `Surbhi is Vice President at Trifecta Capital, where she leads growth investments in technology companies across consumer internet, fintech, and healthtech sectors. Prior to Trifecta, she was with Reliance Jio Strategic Investments leading tech acquisitions across India, Israel, and US. She started her investing journey at GenNext Venture Fund where she established a Jerusalem-based startup incubator and helped set up Jio GenNext's accelerator program in partnership with Microsoft. Her passion lies in working with founders to build category-defining companies and establishing strong governance frameworks.<br/><br/>
Surbhi is a silver medalist from BITS Pilani in Electrical Engineering and holds an MBA from IIM Bangalore. She is an international award winner in painting and enjoys mentoring early-stage founders in their entrepreneurial journey.


         `,
        name:"Surbhi Garg",
        company:"-",
        post:"-",
         oldpost:"VP",
        oldcompany:"Trifecta Capital",
        linkedIn:"https://www.linkedin.com/in/surbhi-garg-12475517/",
    },
    {
        imgUrl: icon11,
        desc: `Varuna Khattri, based in Mumbai, Maharashtra, India, is an Investment Professional at CPP Investments. With a diverse professional background, Varuna has held roles at Shapoorji Pallonji and Company Limited, the Asian Center for Entertainment Education, Takshashila Consulting, and HSBC’s Investment Banking division. Varuna earned a PGDM in Finance from the Indian Institute of Management, Shillong (2011–2013). Equipped with a strong skill set, including expertise in mathematics, writing, root cause analysis, luxury management, consulting, and more, Varuna brings valuable insights to the field.

         `,
        name:"Varuna Khattri",
        company:"-",
        post:"-",
        oldpost:"Senior Associate",
        oldcompany:"CPP Investments",
        linkedIn:"https://www.linkedin.com/in/varunakhattri/?originalSubdomain=in",
    },
     
    
,
    
    
    
    
   
    
     
	
]

export default mentConstant4


// WEBPACK FOOTER //
// ./src/constant/mentConstant4.js